import React from 'react'
import { BsFillXCircleFill } from 'react-icons/bs'
import { MdClose } from 'react-icons/md'

interface CycleValidationError {
  message: string
  automationIds?: number[]
}

interface CycleValidationErrorCardProps {
  validationError: CycleValidationError
  onDismiss: () => void
}

export function CycleValidationErrorCard({
  validationError,
  onDismiss,
}: CycleValidationErrorCardProps) {
  return (
    <div className="bg-red-50 border border-red-200 rounded-md p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <BsFillXCircleFill className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            Automation Conflict Detected
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <p>{validationError.message}</p>
          </div>
        </div>
        <div className="ml-auto pl-3">
          <div className="-mx-1.5 -my-1.5">
            <button
              type="button"
              className="inline-flex bg-red-50 rounded-md p-1.5 text-red-500 hover:bg-red-100"
              onClick={onDismiss}
            >
              <span className="sr-only">Dismiss</span>
              <MdClose className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
